// extracted by mini-css-extract-plugin
module.exports = {"result":"_2kOiU","icon":"_3uNcn","success":"_1K3a8","error":"_1fTlW","title":"Q1hXe","description":"WYwRt","extra":"_3gMHK","actions":"_2kHKA"};